import type {JSONValue} from 'types';
import {mapToCollectionTypeDto} from 'services/series';
import {getOffset} from 'services/utils/getOffset';
import type {SearchProps, SeriesSearchProps} from '../types';
import seriesQuery from '../data/seriesQuery.json';
import {normalizeQuery} from '../functions';

const SERIES_INDEX = 'ebs-series-alias';

export const mapSeriesSearchPropsToSearchProps = ({
  query,
  seriesType,
  page,
  size,
  abortSignal,
}: SeriesSearchProps): SearchProps => {
  const normalizedQuery = normalizeQuery(query);
  const type = mapToCollectionTypeDto(seriesType);
  const from = getOffset(page, size);

  const elasticBody = JSON.parse(
    JSON.stringify(seriesQuery)
      .replaceAll('${QUERY_PLACEHOLDER}', normalizedQuery)
      .replaceAll('${SERIES_TYPE_PLACEHOLDER}', type)
      .replaceAll('"${FROM_PLACEHOLDER}"', String(from))
      .replaceAll('"${SIZE_PLACEHOLDER}"', String(size)),
  ) as JSONValue;

  return {
    target: '_search',
    index: SERIES_INDEX,
    elasticBody,
    abortSignal,
  };
};
